import { RealTime, sharedFriendsService, DeviceMeta, DisplayNames } from 'Roblox';
import { authenticatedUser } from 'header-scripts';
import { abbreviateNumber } from 'core-utilities';
import angular from 'angular';
import placesListModule from '../placesListModule';

function placesListContainer(
  resources,
  $rootScope,
  gamesService,
  layout,
  utility,
  $timeout,
  deviceTypes,
  $document,
  presenceTypes,
  friendsInfoService
) {
  'ngInject';

  return {
    restrict: 'A',
    scope: true,
    replace: true,
    templateUrl: resources.templateUrls.placesListContainer,
    link(scope, element, attrs) {
      scope.getPlaceThumbnails = function(universeIds) {
        if (universeIds && universeIds.length > 0) {
          gamesService.getGameThumbnails(universeIds).then(function(result) {
            if (result && result.length > 0) {
              result.forEach(function(gameThumbnails) {
                const { universeId } = gameThumbnails;
                if (scope.library.placesLibrary[universeId]) {
                  scope.library.placesLibrary[universeId].gameThumbnails =
                    gameThumbnails.thumbnails;
                }
              });
            }
          });
        }
      };

      scope.getPlacesDetails = function(placeIds) {
        if (placeIds && placeIds.length > 0) {
          gamesService.getPlacesDetails(placeIds).then(function(result) {
            if (result && result.length > 0) {
              result.forEach(function(placeDetails) {
                const { universeId } = placeDetails;
                if (scope.library.placesLibrary[universeId]) {
                  scope.library.placesLibrary[universeId].isPlayable = placeDetails.isPlayable;
                  scope.library.placesLibrary[universeId].reasonProhibited =
                    placeDetails.reasonProhibited;
                  scope.library.placesLibrary[universeId].description = placeDetails.description;
                  scope.library.placesLibrary[universeId].placeUrl = layout.getGameDetailsPageUrl(
                    placeDetails.universeRootPlaceId
                  );
                }
              });
            }
          });
        }
      };

      scope.getEachPlacesList = function(sortName) {
        const universeIds = [];
        const placeIds = [];
        const sortInfo = scope.library.knowledgeOfSorts[sortName];
        const numberOfGames = sortInfo.numberOfGames
          ? sortInfo.numberOfGames
          : scope.layout.numberOfGamesFetchInList;
        const pageId =
          scope.library.pageContext && scope.library.pageContext.pageId
            ? scope.library.pageContext.pageId
            : null;
        const sortPosition = pageId ? sortInfo.sortPosition : null;
        gamesService
          .getGamesList(
            sortInfo.token,
            sortInfo.gameSetTargetId,
            numberOfGames,
            sortPosition,
            scope.library.pageContext
          )
          .then(function(result) {
            if (result && result.games && result.games.length > 0) {
              const displayedGames = result.games.slice(0, scope.layout.maxNumberOfGamesInList);
              const displayedGamesCount = displayedGames.length;
              angular.forEach(displayedGames, (game, position) => {
                const place = angular.copy(game);
                place.creatorUrl = layout.getProfilePageUrl(place.creatorId);
                place.playerCountLabel = abbreviateNumber.getAbbreviatedValue(place.playerCount);
                place.creatorByLabel = layout.getCreatorBy(place.creatorUrl, place.creatorName);
                place.votePercentage = utility.getVotePercentage(
                  place.totalUpVotes,
                  place.totalDownVotes
                );
                scope.library.placesLibrary[place.universeId] = place;
                universeIds.push(place.universeId);
                placeIds.push(place.placeId);
              });

              let seeAllUrl = layout.gamesListSeeAllLinks[sortName];
              if (seeAllUrl && pageId && sortPosition) {
                seeAllUrl = seeAllUrl.concat(
                  seeAllUrl.includes('?') ? '&' : '?',
                  'pageId=',
                  pageId,
                  '&sortPosition=',
                  sortPosition
                );
              }
              if (seeAllUrl) {
                seeAllUrl += `#/sortName/${sortName}`;
              }
              angular.forEach(displayedGames, (place, position) => {
                const gameReferralUrl = utility.buildGameReferralUrl(
                  place,
                  sortName,
                  position + 1,
                  displayedGamesCount,
                  sortPosition,
                  pageId
                );
                displayedGames[position].gameReferralUrl = gameReferralUrl;
              });

              scope.library.placesList[sortName] = {
                games: displayedGames,
                seeAllUrl,
                displayName: sortInfo.displayName,
                numberOfGames: displayedGamesCount
              };
              if (!$rootScope.isPlacesListLoaded) {
                $rootScope.isPlacesListLoaded = true;
              }
            } else if (scope.library.placesList[sortName]) {
              scope.library.placesList[sortName] = {};
              const position = scope.library.sortNames.indexOf(sortName);
              scope.library.sortNames.splice(position, 1);
              delete scope.library.knowledgeOfSorts[sortName];
            }
          })
          .then(function() {
            scope.getPlacesDetails(placeIds);
          });
      };

      scope.getAllPlacesList = function() {
        if (scope.library.sortNames && scope.library.sortNames.length > 0) {
          angular.forEach(scope.library.sortNames, function(sortName) {
            scope.getEachPlacesList(sortName);
          });
        }
      };

      scope.countDownTokenExpiration = function() {
        angular.forEach(scope.library.knowledgeOfSorts, function(sort, key) {
          sort.timeout = $timeout(function() {
            sort.hasTokenExpired = true;
            sort.timeout = null;
          }, sort.tokenExpiryInSeconds * 1000);
        });
      };

      scope.$on('$destroy', function(event) {
        angular.forEach(scope.library.knowledgeOfSorts, function(sort, key) {
          $timeout.cancel(sort.timeout);
        });
      });

      scope.updateKnowledgeOfSorts = function(sort, index) {
        const sortName = sort.name;
        if (!scope.library.knowledgeOfSorts[sortName]) {
          scope.library.knowledgeOfSorts[sortName] = sort;
          scope.library.knowledgeOfSorts[sortName].sortFilterId = resources.sortFiterIds[sortName];
        } else {
          scope.library.knowledgeOfSorts[sortName].token = sort.token;
          scope.library.knowledgeOfSorts[sortName].tokenExpiryInSeconds = sort.tokenExpiryInSeconds;
        }
        if (!scope.library.knowledgeOfSorts[sortName].timeout) {
          scope.library.knowledgeOfSorts[sortName].hasTokenExpired = false;
        }
        scope.library.knowledgeOfSorts[sortName].sortPosition = index + 1;
      };

      scope.getSorts = function() {
        gamesService
          .getHomeGameSorts()
          .then(function(result) {
            if (result && result.sorts) {
              scope.library.pageContext = result.pageContext;
              result.sorts.forEach(function(sort, index) {
                const sortName = sort.name;
                scope.library.sortNames.push(sortName);
                scope.updateKnowledgeOfSorts(sort, index);
              });

              scope.countDownTokenExpiration();
            }
          })
          .then(scope.getAllPlacesList);
      };

      scope.refreshPlaceList = function(refreshSortName) {
        if (
          !scope.library.knowledgeOfSorts[refreshSortName] ||
          scope.library.knowledgeOfSorts[refreshSortName].hasTokenExpired
        ) {
          gamesService.getHomeGameSorts().then(function(result) {
            if (result && result.sorts) {
              const sortNames = [];
              result.sorts.forEach(function(sort, index) {
                const sortName = sort.name;
                sortNames.push(sortName);
                if (sortName === refreshSortName) {
                  scope.updateKnowledgeOfSorts(sort, index);
                }
              });

              scope.library.sortNames = sortNames;
              scope.getEachPlacesList(refreshSortName);
              if (
                scope.library.knowledgeOfSorts[refreshSortName] &&
                (scope.library.knowledgeOfSorts[refreshSortName].hasTokenExpired ||
                  !scope.library.knowledgeOfSorts[refreshSortName].timeout)
              ) {
                scope.library.knowledgeOfSorts[refreshSortName].timeout = $timeout(function() {
                  scope.library.knowledgeOfSorts[refreshSortName].hasTokenExpired = true;
                  scope.library.knowledgeOfSorts[refreshSortName].timeout = null;
                }, scope.library.knowledgeOfSorts[refreshSortName].tokenExpiryInSeconds);
              }
            }
          });
        } else {
          scope.getEachPlacesList(refreshSortName);
        }
      };

      scope.handleMyRecentSort = function(data) {
        const type = data.Type;
        if (type) {
          scope.refreshPlaceList(resources.sortName.MyRecent);
        }
      };

      scope.handleUpdateMyFavoriteSort = function(data) {
        const type = data.Type;
        if (type) {
          scope.refreshPlaceList(resources.sortName.MyFavorite);
        }
      };

      scope.listenToPresenceUpdate = function() {
        $document.on('Roblox.Presence.Update', function(event, args) {
          if (args) {
            $timeout(function() {
              const userIdsNotInLibrary = [];
              args.forEach(function(presence) {
                const { userId } = presence;
                if (presence.userPresenceType === presenceTypes.ingame.status) {
                  scope.updatePeopleInGameLibrary(presence, true);
                  if (!scope.library.peopleLibrary[userId]) {
                    scope.library.peopleLibrary[userId] = {
                      userId
                    };
                    userIdsNotInLibrary.push(userId);
                  }
                  scope.library.peopleLibrary[userId].playerCount++;
                } else if (
                  scope.library.peopleLibrary[userId] &&
                  scope.library.peopleLibrary[userId].presence.userPresenceType ===
                    presenceTypes.ingame.status
                ) {
                  // was in game
                  scope.library.peopleLibrary[userId].playerCount--;
                  scope.removeUserIdFromPeopleInGame(userId);
                }
                if (scope.library.peopleLibrary[userId]) {
                  scope.library.peopleLibrary[userId].presence = presence;
                }
              });
            });
          }
        });
      };

      scope.isModalOpenOnThisPlace = function(universeId) {
        return scope.library.modalStatus[universeId]
          ? scope.library.modalStatus[universeId].isOpen
          : false;
      };

      scope.removeUserIdFromPeopleInGame = function(userId) {
        const { universeId } = scope.library.peopleLibrary[userId].presence;
        const { rootPlaceId } = scope.library.peopleLibrary[userId].presence;
        const isModalOpenOnThisPlace = scope.isModalOpenOnThisPlace(universeId);
        let position = 0;
        if (isModalOpenOnThisPlace) {
          if (!scope.library.tempPeopleInGameLibrary[rootPlaceId]) {
            scope.library.tempPeopleInGameLibrary[rootPlaceId] = angular.copy(
              scope.library.peopleInGameLibrary[rootPlaceId]
            );
          }
          position = scope.library.tempPeopleInGameLibrary[rootPlaceId].indexOf(userId);
          scope.library.tempPeopleInGameLibrary[rootPlaceId].splice(position, 1);
        } else {
          position = scope.library.peopleInGameLibrary[rootPlaceId].indexOf(userId);
          scope.library.peopleInGameLibrary[rootPlaceId].splice(position, 1);
        }
      };

      scope.updatePeopleInGameLibrary = function(presence, isRealTimeUpdate) {
        const { rootPlaceId } = presence;
        const { universeId } = presence;
        const { userId } = presence;
        if (!scope.library.peopleInGameLibrary[rootPlaceId]) {
          scope.library.peopleInGameLibrary[rootPlaceId] = [];
        }

        if (scope.library.peopleInGameLibrary[rootPlaceId].indexOf(userId) < 0) {
          if (isRealTimeUpdate) {
            const isModalOpenOnThisPlace = scope.isModalOpenOnThisPlace(universeId);
            if (isModalOpenOnThisPlace) {
              scope.library.tempPeopleInGameLibrary[rootPlaceId] = angular.copy(
                scope.library.peopleInGameLibrary[rootPlaceId]
              );
              scope.library.tempPeopleInGameLibrary[rootPlaceId].push(userId);
            } else {
              scope.library.peopleInGameLibrary[rootPlaceId].unshift(userId);
            }
          } else {
            scope.library.peopleInGameLibrary[rootPlaceId].push(userId);
          }
        }
      };

      scope.getFriendsInfo = function(friends) {
        const userIds = [];
        angular.forEach(friends, (friend, userId) => {
          const currentFriend = friend;
          userIds.push(userId);
          if (friend.presence && friend.presence.userPresenceType === presenceTypes.ingame.status) {
            scope.updatePeopleInGameLibrary(friend.presence);
          }
          currentFriend.nameToDisplay = DisplayNames?.Enabled() ? friend.displayName : friend.name;
        });
        scope.library.peopleLibrary = angular.copy(friends);
      };

      scope.initializeRealTimeSubscriptions = function() {
        realTimeClient.Subscribe(
          resources.notificationNames.gameFavoriteNotifications,
          scope.handleUpdateMyFavoriteSort
        );
        realTimeClient.Subscribe(
          resources.notificationNames.gameCloseNotifications,
          scope.handleMyRecentSort
        );
      };

      let realTimeClient;
      scope.setup = function() {
        scope.layout = layout;
        scope.library = {
          placesList: {},
          placesLibrary: {},
          sortNames: [],
          knowledgeOfSorts: {},
          userId: authenticatedUser?.id,
          isAvatarInPlacesListEnabled: false,
          peopleLibrary: {},
          peopleInGameLibrary: {},
          tempPeopleInGameLibrary: {},
          modalStatus: {}
        };
        if (angular.isDefined(RealTime)) {
          realTimeClient = RealTime.Factory.GetClient();
        }

        const deviceType = DeviceMeta() ? DeviceMeta().deviceType : '';
        if (deviceType.toLowerCase() === deviceTypes.COMPUTER.toLowerCase()) {
          scope.library.isAvatarInPlacesListEnabled = true;
        }
      };

      scope.init = function() {
        scope.setup();
        scope.getSorts();

        scope.initializeRealTimeSubscriptions();
        if (scope.library.isAvatarInPlacesListEnabled) {
          const { cacheCriteria } = resources;
          sharedFriendsService.register(scope.getFriendsInfo, cacheCriteria);
          scope.listenToPresenceUpdate();
        }
      };

      scope.init();
    }
  };
}

placesListModule.directive('placesListContainer', placesListContainer);

export default placesListContainer;
